import { render, staticRenderFns } from "./ib-popover.vue?vue&type=template&id=c1875f8a&lang=pug&"
import script from "./ib-popover.vue?vue&type=script&lang=js&"
export * from "./ib-popover.vue?vue&type=script&lang=js&"
import style0 from "./ib-popover.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ib-popover.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1875f8a')) {
      api.createRecord('c1875f8a', component.options)
    } else {
      api.reload('c1875f8a', component.options)
    }
    module.hot.accept("./ib-popover.vue?vue&type=template&id=c1875f8a&lang=pug&", function () {
      api.rerender('c1875f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view/ib-popover.vue"
export default component.exports